import { ANALYTICS_ID } from '../config/dev.env'

function enableAnalytics () {
  window['ga-disable-' + JSON.parse(ANALYTICS_ID)] = false
  gtag('js', new Date())
  gtag('config', JSON.parse(ANALYTICS_ID), { 'anonymize_ip': true })
}

function disableAnalytics () {
  window['ga-disable-' + JSON.parse(ANALYTICS_ID)] = true
}

function gtag () { window.dataLayer.push(arguments) }
window.enableAnalytics = enableAnalytics
window.disableAnalytics = disableAnalytics
window.dataLayer = window.dataLayer || []
window.gtag = gtag

if ((typeof (Storage) !== 'undefined'
  ? localStorage.getItem('isAnalyticsEnabled')
    ? localStorage.getItem('isAnalyticsEnabled')
    : 'false'
  : 'false') === 'true') {
  enableAnalytics()
} else {
  disableAnalytics()
}

if (typeof (Storage) !== 'undefined' && !localStorage.getItem('isAnalyticsEnabled')) { localStorage.setItem('cookiePolicyRead', 'false') }



//////////////////
// WEBPACK FOOTER
// ./static/init.js
// module id = 172
// module chunks = 10